function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefreshIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#6c757d",
  strokeMiterlimit: 10,
  d: "M15 3a11.97 11.97 0 0 0-7.793 2.875 1 1 0 1 0 1.299 1.52A9.95 9.95 0 0 1 15 5a9.986 9.986 0 0 1 9.951 9H22l4 6 4-6h-3.05C26.437 7.852 21.277 3 15 3M4 10l-4 6h3.05C3.563 22.148 8.723 27 15 27c2.969 0 5.697-1.083 7.793-2.875a1 1 0 1 0-1.299-1.52A9.95 9.95 0 0 1 15 25a9.986 9.986 0 0 1-9.951-9H8z",
  fontFamily: "none",
  fontSize: "none",
  fontWeight: "none",
  style: {
    mixBlendMode: "normal"
  },
  textAnchor: "none",
  transform: "scale(8.53333)"
}));
export default SvgRefreshIcon;